import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { Text } from "@cars24/turbo-web/lib/text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";
import formatInputValue from "../../../utils/helpers/format-input-value";

const EChallanRegNoList = ({ regNumberList, updateRegNumber }) => {

    const { tokens } = useTokens();

    return (
        <div styleName={`styles.wrapper`}>
            {
                regNumberList?.map((item, index) => {
                    return item?.vehicleRegNo ? (
                        <div
                            onClick={e => updateRegNumber(e, item?.vehicleRegNo)}
                            key={index}
                            className="shrinkOnTouch"
                            styleName={"styles.listItem"}
                        >
                            <Text
                                size={"150"}
                                fontWeight="medium"
                                color={tokens.text_default_text_primary}
                            >
                                {formatInputValue(item?.vehicleRegNo)}
                            </Text>
                        </div>
                    ) : null;
                })
            }
        </div>
    );
};

EChallanRegNoList.propTypes = {
    regNumberList: PropTypes.array,
    updateRegNumber: PropTypes.func
};

export default EChallanRegNoList;
